import { render, staticRenderFns } from "./fccTiposDadosCadastrais.vue?vue&type=template&id=5c59322f"
import script from "./fccTiposDadosCadastrais.vue?vue&type=script&lang=js"
export * from "./fccTiposDadosCadastrais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports